import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'destructive' | 'outline' | 'link';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  full?: boolean;
  icon?: ReactNode;
}

/**
 * Disabled buttons are muted, non-clickable and non-focusable through the real
 * `disabled` attribute; callers guard their handlers independently.
 */
export function Button({ variant = 'primary', size = 'md', full, icon, className, children, type = 'button', ...rest }: ButtonProps) {
  const cls = [styles.button, styles[variant], size !== 'md' ? styles[size] : '', full ? styles.full : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={cls} {...rest}>
      {icon}
      {children}
    </button>
  );
}
